import React from 'react'

// hooks
import { useTheme, IconButton, Tooltip } from '@material-ui/core'

// types
import { Folder } from '../../models'

// components
import { Container } from '../Container'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import SwapVertIcon from '@material-ui/icons/SwapVert'
import { typographyStyle } from '../../theme/typographyStyle'

interface Props {
    folder: Folder
    open: boolean
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
    getFolderAdornment?: (folder: Folder) => JSX.Element | null
    enableSorting?: boolean
    sortOrder?: 'asc' | 'desc'
    onSortToggle?: () => void
    hasChildren?: boolean
}

export const SortableFinderFolder: React.FC<Props> = (props) => {
    const {
        folder,
        open,
        onClick,
        enableSorting,
        sortOrder,
        onSortToggle,
        hasChildren,
    } = props

    const theme = useTheme()

    const expandIcon = open ? (
        <KeyboardArrowDownIcon />
    ) : (
        <KeyboardArrowRightIcon />
    )

    const sortIcon = <SwapVertIcon />
    const sortTooltip =
        sortOrder === 'asc' ? 'Sort descending' : 'Sort ascending'

    return (
        <Container
            direction="column"
            flex={1}
            onClick={(e) => {
                e.stopPropagation()
                onClick && onClick(e)
            }}
        >
            <Container alignItems="center" flex={1}>
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation()
                        onClick && onClick(e as any)
                    }}
                    disabled={!hasChildren}
                >
                    {expandIcon}
                </IconButton>

                <span
                    style={{
                        ...typographyStyle(theme.typography.body2),
                        fontWeight: 700,
                        marginLeft: theme.spacing(0.5),
                    }}
                >
                    {folder.name}
                </span>

                {props.getFolderAdornment && props.getFolderAdornment(folder)}

                {enableSorting && hasChildren && (
                    <Container style={{ marginLeft: 'auto' }}>
                        <Tooltip title={sortTooltip}>
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onSortToggle && onSortToggle()
                                }}
                            >
                                {sortIcon}
                            </IconButton>
                        </Tooltip>
                    </Container>
                )}
            </Container>
        </Container>
    )
}
